
import { Messages } from '~src/codegen/Localize';
import { ModalInstance } from '~src/commonInfra/dialogs/ReactModalService';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { removeQueryParamFromString } from '~src/commonInfra/services/WindowLocationService';
import { UrlParamKeys } from '~src/commonInfra/url/UrlParamKeys';
import { ITypedId } from '~src/httpClient/serverApi/types/ITypedId';
import { GrantAccessPermissionsHelper } from '~src/permissions/utils/GrantAccessPermissionsHelper';
import { sendGrantAccessEmailClickedTelemetry } from '~src/requestAccess/telemetry/RequestAccessTelemetry';
import { GrantPermissionsAfterSharingDialog } from '~src/sharing/components/namedSharing/GrantPermissionsAfterSharingDialog';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { UserNames } from '~src/userManagement/resources/UserNames';
import { ISiteUser } from '~src/userManagement/users/serverApi/types/ISiteUser';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { RequestAccessContent, RequestAccessDialog } from '../components/RequestAccessDialog';

export namespace RequestAccessAction {
  let dialogWithPreviewModalInstance: ModalInstance<unknown>;

  export function handleRequestAccess(requestAccessContent: RequestAccessContent, resultUrl: string) {
    RequestAccessDialog.open(requestAccessContent);
  }

  export async function handleGrantAccess(contentInfo: IContentInfo<ExplorableItemType>, resultUrl: string) {
    sendGrantAccessEmailClickedTelemetry(contentInfo.contentType);
    const requestorId = getUserIdFromUrl(resultUrl);
    if (requestorId !== undefined && requestorId !== '') {
      const userInfo = await getUserInfo(requestorId);

      if (userInfo?.displayName !== null) {
        const permissionResult = await GrantAccessPermissionsHelper.canUserGrantPermission(contentInfo);
        if (permissionResult.canGrantPermissions) {
          var recipients = requestorId ? [{ recipientType: 'user', recipientId: Number(requestorId) }] : [];
          const usersWithoutReadPermissions: (IUser | ISiteUser)[] = await GrantAccessPermissionsHelper.getUsersWithoutReadPermissionsForContent(recipients, contentInfo);
          // Verify that the user hasn't already been granted permissions
          if (usersWithoutReadPermissions.length > 0) {
            const unpermissionedRecipients: ITypedId[] = usersWithoutReadPermissions.map(user => {
              return { type: 'user', id: user.id };
            });
            GrantPermissionsAfterSharingDialog.open({ content: contentInfo, shareRecipients: recipients, unpermissionedRecipients, sourceAuthorizable: permissionResult.sourceAuthorizable, isRequestAccessDialogEnabled: true, requesterName: userInfo.displayName, requesterUsername: userInfo.username });
          }
        }
      } else {
        ToasterService.instance.pop({
          type: ToastType.Warning,
          text: Messages.requestAccessUserRemoved(),
        });
      }
  }
  }

  export function getUserIdFromUrl(url: string) {
    const grantAccessString = 'grantAccess/users/';
    const userIndex = url.lastIndexOf(grantAccessString);

    if (userIndex === -1) {
      return undefined; // No user identifier found
    }
    let userIdentifier = url.substring(userIndex + grantAccessString.length);

    // Check if the URL contains the isFromSaml parameter
    if (userIdentifier.includes(UrlParamKeys.IsFromSaml)) {
      // Remove the isFromSaml parameter
      userIdentifier = removeQueryParamFromString(userIdentifier, UrlParamKeys.IsFromSaml);
    }

    return userIdentifier;
  }

  export async function getUserInfo(id: string): Promise<{ displayName: string, username: string }> {
    const userInfo = await UserNames.getById(id);
    return userInfo === null ? null : { displayName: userInfo.displayName, username: userInfo.username };
  }
}

export type RequestAccessAction = typeof RequestAccessAction;